import Alpine from 'alpinejs';
import products from './components/products';
import cart from './components/cart';
import nav from './components/nav';
import qr from './components/qr'
import orderDone from './components/order-done';

export default () => {
	Alpine.data('products', products),
	Alpine.data('cart', cart)
	Alpine.data('nav', nav)
	Alpine.data('qr', qr),
	Alpine.data('orderDone', orderDone)
}